module.exports = __webpack_public_path__ + "img/icon_check circled_outline_.15c5b8ed.svg";